import { useParams, Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import styles from './EventSuccess.module.css';

export default function EventSuccess() {
  const { shortCode } = useParams();

  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <div className={styles.stateCard}>
          <div className={`${styles.stateIcon} ${styles.stateIconSuccess}`}>
            <CheckCircle size={28} />
          </div>
          <h1 className={styles.stateTitle}>You're registered</h1>
          <p className={styles.stateBody}>
            Check your email for confirmation and event details.
          </p>
          {shortCode && (
            <Link to={`/e/${shortCode}`} className={styles.backLink}>
              ← Back to event
            </Link>
          )}
        </div>

        <p className={styles.footer}>
          Powered by <a href="/" className={styles.footerBrand}>Vennio</a>
        </p>
      </div>
    </div>
  );
}
